import type { Components } from '@mui/material/styles/components';

export const MuiSlider: Components['MuiSlider'] = {
  styleOverrides: {
    root: () => ({
      padding: 0,
      marginBottom: '16px',
      [`@media (pointer: coarse)`]: {
        padding: 0,
      },
      '& .MuiSlider-markLabel[data-index="0"]': {
        transform: 'translateX(0)',
      },
      // NOTE: last-child didn't work
      [`.MuiSlider-markLabel[style*="left: 100%"]`]: {
        transform: 'translateX(-100%) !important',
      },
    }),
    rail: () => ({
      backgroundColor: '#EEF2FD',
    }),
    thumb: () => ({
      border: '4px solid #EEF2FD',
    }),
    markLabel: () => ({
      top: '16px',
      color: '#939DB8',
      [`@media (pointer: coarse)`]: {
        top: '16px',
      },
      '&:last-child': {
        right: 0,
        transform: 'translateX(0) !important',
        color: 'red',
      },
    }),
    mark: () => ({
      backgroundColor: 'transparent',
    }),
  },
};
